import { BaseSecondSidebarPageContent } from "../../shared/components/base/page/BaseSecondSidebarPageContent";
import { IConnectRender } from "../../shared/components/definitions/IConnectRender";
import { TareaEjecucionMapRender } from "../../shared/components/modulos/rastro/map/TareaEjecucionMapRender";
import { TareaEjecucionSecondSidebarRender } from "../../shared/components/modulos/rastro/sidebar/TareaEjecucionSecondSidebarRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_FINCA } from "../components/ClienteAsideMenuRender";

/** Página del módulo de Tareas (rastro): segundo sidebar (ejecuciones de
 *  tarea por año/mes/día) + mapa con las ejecuciones del día seleccionado. */
export class TareasPage extends BaseSecondSidebarPageContent {
  /** Mapa vivo de la página (el sidebar le cambia el día / togglea ejecuciones). */
  private _mapRender: TareaEjecucionMapRender | null = null;

  /** El mapa de ejecuciones de tarea (contenido principal). */
  protected getMainRender(): IConnectRender {
    this._mapRender = new TareaEjecucionMapRender();
    return this._mapRender;
  }

  /** Sidebar de Tareas: volver → mapa de finca; día → dibuja sus ejecuciones;
   *  toggle → prende/apaga una ejecución puntual. */
  protected getSecondSidebarRender(): IConnectRender {
    return new TareaEjecucionSecondSidebarRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA),
      (dia) => this._mapRender?.setDia(dia),
      (ejecucionId, visible) =>
        this._mapRender?.toggleEjecucion(ejecucionId, visible),
    );
  }
}
